import { useTheme } from '@emotion/react';
import { Card, Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';
import Screen from '../../components/fragments/Screen';
import useSettings from '../../hooks/useSettings';

const SCREEN_WIDTH = window.innerWidth;

export default function SettingsScreen() {
    const { themeMode, layout, onChangeMode, onChangeLayout } = useSettings();

    return (
        <Screen title={'Settings'}>
            <Setting
                title="App Theme"
                value={themeMode}
                options={['light', 'dark']}
                leftAction={() => {
                    const mode = { target: { value: 'light' } };
                    onChangeMode(mode);
                }}
                rightAction={() => {
                    const mode = { target: { value: 'dark' } };
                    onChangeMode(mode);
                }}
                left={
                    <div>
                        Light
                        {[1, 2, 3].map((t) => (
                            <Skeleton
                                key={t}
                                className="mt-2 bg-light"
                                variant="rectangular"
                                width={SCREEN_WIDTH / 2 - 56}
                                height={15}
                                animation={false}
                            />
                        ))}
                    </div>
                }
                right={
                    <div>
                        Dark
                        {[1, 2, 3].map((t) => (
                            <Skeleton
                                key={t}
                                className="mt-2 bg-dark"
                                variant="rectangular"
                                width={SCREEN_WIDTH / 2 - 56}
                                height={15}
                                animation={false}
                            />
                        ))}
                    </div>
                }
            />
            <Setting
                title="Feed Layout"
                value={layout}
                options={['normal', 'spaced']}
                leftAction={() =>
                    onChangeLayout({
                        target: {
                            value: 'normal',
                        },
                    })
                }
                rightAction={() =>
                    onChangeLayout({
                        target: {
                            value: 'spaced',
                        },
                    })
                }
                left={
                    <>
                        <div className="d-flex">
                            <Skeleton
                                variant="circular"
                                width={40}
                                height={40}
                                animation={false}
                            />
                            <Skeleton
                                style={{ marginLeft: 4 }}
                                className="my-2"
                                variant="rectangular"
                                width={SCREEN_WIDTH / 2 - 100}
                                height={20}
                                animation={false}
                            />
                        </div>
                        <Skeleton
                            className="mt-2 "
                            style={{ marginLeft: 8 }}
                            variant="rectangular"
                            width={SCREEN_WIDTH / 2 - 64}
                            height={60 - 13}
                            animation={false}
                        />
                    </>
                }
                right={
                    <>
                        <div>
                            <Skeleton
                                variant="circular"
                                width={40}
                                height={40}
                                animation={false}
                            />
                        </div>
                        <div>
                            <Skeleton
                                style={{ marginLeft: 4 }}
                                className="my-2"
                                variant="rectangular"
                                width={SCREEN_WIDTH / 2 - 100}
                                height={20}
                                animation={false}
                            />
                            <Skeleton
                                style={{ marginLeft: 4 }}
                                variant="rectangular"
                                width={SCREEN_WIDTH / 2 - 100}
                                height={60}
                                animation={false}
                            />
                        </div>
                    </>
                }
            />
        </Screen>
    );
}

const Setting = ({
    title,
    value,
    options,
    left,
    right,
    leftAction,
    rightAction,
}) => {
    const theme = useTheme();

    return (
        <Grid item xs={12}>
            <div className="m-2">
                <Typography
                    color="textPrimary"
                    style={{ fontWeight: 'bold' }}
                    noWrap={false}
                    className="text-capitalize"
                >
                    {title}
                </Typography>
            </div>
            <Card
                className="d-flex justify-content-between"
                variant="outlined"
                style={{ borderWidth: 2, padding: 16 }}
            >
                <div
                    onClick={leftAction}
                    style={{
                        border:
                            value === options[0] &&
                            `2px solid ${theme.palette.primary.main}`,
                        borderRadius: theme.shape.borderRadius,
                        padding: 8,
                    }}
                >
                    {left}
                </div>
                <div
                    onClick={rightAction}
                    className="d-flex justify-content-between"
                    style={{
                        border:
                            value === options[1] &&
                            `2px solid ${theme.palette.primary.main}`,
                        borderRadius: theme.shape.borderRadius,
                        padding: 8,
                    }}
                >
                    {right}
                </div>
            </Card>
        </Grid>
    );
};
